export default __webpack_public_path__ + "static/media/CreditCardShieldOrange.4426331a.svg";